import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'text-brand-bioderma mx-auto mt-12 flex max-w-[1100px] flex-col gap-5 max-lg:px-5 lg:mt-20 lg:flex-row lg:items-end lg:gap-15',
    photo: 'max-lg:max-w-[121px]',
    info: 'flex min-w-[240px] gap-4 lg:flex-col lg:gap-5',
    name: 'mb-1 text-[16px] leading-[1.4] font-medium lg:text-[20px]',
    position: 'mb-2 text-[12px] leading-[1.5] font-light lg:text-[14px]',
    quote: 'relative',
    text: 'text-brand-bioderma text-[16px] leading-[1.8] font-medium lg:text-[18px]',
    readMore:
      'text-brand-bioderma mt-5 flex cursor-pointer items-center gap-2 text-[14px] leading-[1.2] font-medium tracking-[0.06em] uppercase lg:hidden',
    readMoreIcon: 'size-4 rotate-90 transition-transform duration-200',
    quoteStart:
      'mb-3 max-lg:absolute max-lg:-top-[45px] max-lg:right-0 max-lg:max-w-[28px]',
    quoteEnd:
      'absolute right-0 -bottom-1 max-lg:max-w-[28px] lg:right-0 lg:bottom-1 xl:-right-4'
  },
  variants: {
    isExpanded: {
      false: {
        text: 'max-lg:line-clamp-5'
      },
      true: {
        readMoreIcon: '-rotate-90'
      }
    }
  },
  defaultVariants: {
    isExpanded: false
  }
});
